// account transaction status
export const TRANSACTION_STATUS = [
  "Pending",
  "Accepted",
  "Rejected",
  "Authorising",
] as const;
export type TransactionStatus = typeof TRANSACTION_STATUS[number];

// Bill request status code
export const BILL_REQUEST_STATUS = [
  "Scheduled",
  "Completed",
  "Failed",
  "Retrying",
] as const;
export type BillRequestStatus = typeof BILL_REQUEST_STATUS[number];

// bill request type
export const BILL_REQUEST_TYPES = ["Normal", "Hot", "NewVersion"] as const;
export type BillRequestType = typeof BILL_REQUEST_TYPES[number];

// bill type
export const BILL_TYPES = [
  ...BILL_REQUEST_TYPES,
  "Manual",
  "CreditNote",
] as const;
export type BillType = typeof BILL_TYPES[number];

// bill status
export const BILL_STATUS = ["Accepted", "Draft", "ReadyForAcceptance"] as const;
export type BillStatus = typeof BILL_STATUS[number];

export const CREDIT_STATUS = [
  "Draft",
  "Authorised",
  "Rejected",
  "ReadyForDistribution",
] as const;
export type CreditStatus = typeof CREDIT_STATUS[number];

export const PAYMENT_STATUS = [
  "PendingAuthorisation",
  "Pending",
  "Successful",
  "Cancelled",
];
export type PaymentStatus = typeof PAYMENT_STATUS[number];

export const BILL_FILE_STATUS = [
  "Ready", // OK
  "NotFound", // file not found in file system
  "GdprRemoval", // file marked as removed
] as const;
export type BillFileStatus = typeof BILL_FILE_STATUS[number];

export type BillFileInfo = {
  id: string;
  orderNo: string;
  fileType: string;
  url: string | null;
  status: BillFileStatus;
};
